export default [
  {
    path: "/",
    name: "login",
    meta: {
      title: "Login ",
      authRequired: false,
    },
    component: () => import("../views/authentications/login.vue"),
  },
  {
    path: "/forgot",
    name: "admin_reset",
    meta: {
      title: "Reset Password",
      authRequired: false,
    },
    component: () => import("../views/authentications/forgot_password.vue"),
  },
];
